export default __webpack_public_path__ + "static/media/ikoni_kehitys.6d01ad16.svg";